import React from "react";
import flatCube from "assets/flat-cube.svg";

function LoaderShell(props) {
    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto pt-40 text-center">
                <div className="absolute inset-y-1/3 inset-x-1/3 z-10">
                    <img
                        src={flatCube}
                        className="spinner mx-auto d-block"
                        alt="loading"
                    />
                </div>
            </div>
        </div>
    );
}

export default LoaderShell;
